import React from 'react';
import { Reveal, StaggerReveal, Eyebrow } from '../ui';

import screenLogin     from '../../assets/images/screen_login.jpg';
import screenOtp       from '../../assets/images/screen_otp.jpg';
import screenPhotos    from '../../assets/images/screen_photos.jpg';
import screenInterests from '../../assets/images/screen_interests.jpg';

const gsSteps = [
  { num: '01', screen: screenLogin,     title: 'Create an account',   desc: 'Sign up with email, phone, Google, or Apple — whichever is easiest.' },
  { num: '02', screen: screenOtp,       title: 'Verify your number',  desc: 'Enter the 6-digit code sent to your phone. Quick, secure, takes seconds.' },
  { num: '03', screen: screenPhotos,    title: 'Build your profile',  desc: 'Add up to 6 photos, write your bio, and fill in your occupation. Be yourself.' },
  { num: '04', screen: screenInterests, title: 'Pick your interests', desc: 'Choose up to 10 interests and start discovering people who share your world.' },
];

export default function GetStarted() {
  return (
    <section className="pt-0 pb-16 lg:pt-0 lg:pb-[100px] px-[5%] bg-white" id="get-started">
      <Reveal><Eyebrow>Getting started</Eyebrow></Reveal>
      <Reveal delay={100}>
        <h2 className="text-[clamp(28px,4vw,44px)] font-bold tracking-[-1.2px] mb-8 lg:mb-16">Up and running in minutes</h2>
      </Reveal>
      <StaggerReveal className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {gsSteps.map((s) => (
          <div key={s.num} className="bg-blush rounded-[24px] overflow-hidden hover:-translate-y-2 hover:shadow-[0_24px_48px_rgba(0,0,0,0.1)] transition-all duration-300">
            <div className="p-5 pb-0 flex justify-center">
              <div className="w-[110px] h-[225px] bg-black rounded-[20px] p-[6px] shadow-[0_16px_32px_rgba(0,0,0,0.12)] overflow-hidden">
                <img src={s.screen} alt={s.title} className="w-full h-full object-cover rounded-[15px] block" />
              </div>
            </div>
            <div className="p-6 pt-5">
              <span className="text-[11px] font-semibold tracking-[2px] uppercase text-rose block mb-2">Step {s.num}</span>
              <h3 className="text-lg font-bold tracking-tight mb-2">{s.title}</h3>
              <p className="text-[13px] text-muted leading-relaxed">{s.desc}</p>
            </div>
          </div>
        ))}
      </StaggerReveal>
    </section>
  );
}
